import type { IdGenerator } from '../../application/ports/IdGenerator';
import { SecureRandomUnavailableError } from '../../application/errors/IdGenerationError';
import { asDomainId, type DomainId } from '../../domain/shared/ids';

export interface CryptoSource {
  readonly randomUUID?: Crypto['randomUUID'];
  readonly getRandomValues?: Crypto['getRandomValues'];
}

function uuidV4FromBytes(bytes: Uint8Array): string {
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export class CryptoIdGenerator implements IdGenerator {
  public constructor(private readonly cryptoSource: CryptoSource | null = globalThis.crypto) {}

  public generate<Id extends DomainId>(): Id {
    if (typeof this.cryptoSource?.randomUUID === 'function') {
      return asDomainId<Id>(this.cryptoSource.randomUUID.call(this.cryptoSource));
    }

    if (typeof this.cryptoSource?.getRandomValues === 'function') {
      const bytes = new Uint8Array(16);
      this.cryptoSource.getRandomValues.call(this.cryptoSource, bytes);
      return asDomainId<Id>(uuidV4FromBytes(bytes));
    }

    throw new SecureRandomUnavailableError();
  }
}
